
import video from '../Media/vys.mp4'
import poster from '../Media/poster.png'

import { motion } from "framer-motion";

import VideoPlayer from "react-video-js-player"
const VysProject = () => {
  const videoSrc = video
  return (
    <div className="vys_projectEmp">
        <section>
        <motion.div   
         initial={{ opacity: 0 }}
         animate={{ opacity: 1 }}
         transition={{ delay: 3, duration: 1 }}
         >
           
          <h1>Veritabanı Yönetim Sistemleri <span> Proje Sunum Videosu
            </span></h1>

        <VideoPlayer 
            src={videoSrc}
            poster={poster}
            width ="920" 
            height ="auto"
            controls
            autoplay  ={false}
        />

      </motion.div>

       
        </section>
       
        



    </div>
  );
};

export default VysProject;